import { Injectable } from '@angular/core';
import dayjs from 'dayjs';

@Injectable()
export class FormatService {
  constructor() {
  }

  formatPatientNameForHeader(firstName: string, lastName: string): string {
    return lastName + ', ' + firstName;
  }

  formatPatientNameForList(firstName: string, lastName: string): string {
    return `${ firstName } ${ lastName }`;
  }

  formatAvatarLabel(firstName: string, lastName: string): string {
    return firstName[0].toUpperCase() + lastName[0].toUpperCase();
  }

  formatDateOfBirth(dateOfBirth: Date) {
    return dayjs(dateOfBirth).format('MM/DD/YYYY');
  }

  formatAge(dateOfBirth: Date) {
    return Math.trunc(this.getAge(dateOfBirth)).toString();
  }

  // noinspection JSMethodCanBeStatic
  private getAge(birthDate: Date): number {
    const today = dayjs(new Date()).startOf('day');
    const other = dayjs(birthDate).startOf('day');
    return today.diff(other, 'years');
  }
}
